import React, { ReactNode } from "react";
import { Logger } from "../logging/logger";
import { PluginOwner } from "./PluginRegistryTypes";
import { AlertBox } from "@vp/swan";

interface ErrorBoundaryProps {
  component?: string;
  children?: ReactNode | ReactNode[];
  pluginName: string;
  contactInfo: PluginOwner;
  isDebug: boolean;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error;
}

class PluginErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  private pluginName: string;
  private contactInfo: PluginOwner;
  private isDebug: boolean;

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.pluginName = props.pluginName;
    this.contactInfo = props.contactInfo;
    this.isDebug = props.isDebug;
    this.state = { hasError: false, error: { name: "", message: "", stack: "" } };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error: Error) {
    Logger.instance.error("Plugin threw an error!", {
      errorMessage: error.message,
      errorStack: error.stack,
      pluginName: this.pluginName,
      ownerName: this.contactInfo.ownerName,
    });
  }

  render() {
    if (this.state.hasError) {
      if (this.isDebug) {
        return <AlertBox skin="error">{`Error: ${this.state.error.message}`}</AlertBox>;
      }
      return <></>;
    }
    return this.props.children;
  }
}

export default PluginErrorBoundary;
